module.exports = __webpack_public_path__ + "static/media/009-uganda.f0b868a5.svg";